module.exports = __webpack_public_path__ + "static/media/f.46ec08d0.svg";